import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import { _T } from 'appI18n';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import Carousel from 'react-components/Carousel';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { formatMoney } from 'utils.ts';
import { toLocationHref } from '../../link-utils';
import TourVariantSelector from '../TourVariantSelector';
import { useStyles } from './styles';
import TourSummary from './TourSummary';
function TourTitle({ title, type, url, href, forceDocumentNavigation }) {
    return (React.createElement(React.Fragment, null,
        type && React.createElement(Typography, { variant: "overline" }, type),
        React.createElement(Typography, { variant: "h5", gutterBottom: true }, forceDocumentNavigation
            ? React.createElement(Link, { href: href }, title)
            : React.createElement(Link, { component: RouterLink, to: url }, title))));
}
function TourLocation(props) {
    return (React.createElement(React.Fragment, null,
        props.direction && React.createElement(Typography, { variant: "subtitle1" }, props.direction),
        props.accmmd &&
            React.createElement(Typography, { variant: "subtitle1", gutterBottom: true },
                props.accmmd.countryName,
                ", ",
                props.accmmd.cityName,
                ", ",
                props.accmmd.hotelName)));
}
function TourDescription({ description }) {
    return (React.createElement("p", null, description));
}
function TourActions({ tourUrl, tourHref, tourVariant, priceItem, book, forceDocumentNavigation, classes }) {
    return (React.createElement("div", { className: classes.actionBox },
        React.createElement("div", { className: classes.priceBox },
            React.createElement(Typography, { variant: "overline", gutterBottom: true, className: classes.priceLabel }, _T.COMMON_PRICE_FROM),
            React.createElement(Typography, { variant: "h4", color: "primary", gutterBottom: true, className: classes.priceValue },
                formatMoney(priceItem.price, { currency: tourVariant.currency.name }),
                " ",
                tourVariant.currency.name)),
        React.createElement("div", { className: classes.actionButtons },
            forceDocumentNavigation
                ? React.createElement("a", { href: tourHref, className: classes.actionLink },
                    React.createElement(Button, { variant: "contained", color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null), fullWidth: true, className: classes.actionButton }, _T.COMMON_VIEW))
                : React.createElement(RouterLink, { to: tourUrl, className: classes.actionLink },
                    React.createElement(Button, { variant: "contained", color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null), fullWidth: true, className: classes.actionButton }, _T.COMMON_VIEW)),
            React.createElement(Box, { mt: 1 },
                React.createElement(Button, { variant: "contained", color: "primary", startIcon: React.createElement(ShoppingCartOutlinedIcon, null), onClick: book, fullWidth: true, className: classes.actionButton }, _T.COMMON_BUY)))));
}
/**
 * Карточка с туром.
 */
function TourSearchResultCard(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const [isOpen, setIsOpen] = useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    //const [cheapestVariant, _, cheapestAccmd] = useMemo(() => {
    //    const result = props.item.findCheapestTourVariant();
    //    if (!result)
    //        return result;
    //    // FIXME: сложные туры пока не обрабатываем, поэтому берем данные только для первого
    //    // периода проживания.
    //    try {
    //        return [
    //            result[0],
    //            result[1] ? result[1][0][0] : undefined,
    //            result[1] ? result[1][0][1] : undefined
    //        ] as const;
    //    } catch (e) {
    //        console.error(e);
    //        debugger;
    //    }
    //}, [props.item])!;
    const [cheapestVariant, cheapestPriceItem] = useMemo(() => {
        const result = props.item.findCheapestTourVariant();
        if (!result)
            return result;
        // FIXME: сложные туры пока не обрабатываем, поэтому берем данные только для первого
        // периода проживания.
        try {
            if (!result[1])
                throw new Error('price not found');
            return result;
            //return [
            //    result[0],
            //    result[1].priceItem,
            //    result[1].accomodationVariants
            //] as const;
        }
        catch (e) {
            console.error(e);
            debugger;
        }
    }, [props.item]);
    const cheapestAccmdIds = useMemo(() => { var _a; return (_a = cheapestPriceItem.accomodationVariants) === null || _a === void 0 ? void 0 : _a.map((x) => x.id); }, [cheapestPriceItem]);
    const tourUrl = useMemo(
    // TODO
    () => props.genUrl(cheapestVariant.id, cheapestAccmdIds, cheapestPriceItem.priceItem.servicesHash), 
    //() => props.genUrl(cheapestVariant.id, cheapestVariant.accomodationPeriods.length > 1 ? cheapestVariant.accomodationPeriods.map(a => a.accomodationVariants[0].id) : cheapestAccmd?.id),
    [props.genUrl, cheapestVariant.id, cheapestAccmdIds, cheapestPriceItem.priceItem.servicesHash]);
    const tourHref = useMemo(() => toLocationHref(tourUrl), [tourUrl]);
    const resolveImageUrl = (image) => {
        var _a, _b, _c, _d, _e, _f;
        if (isSmallScreen) {
            if (isXs)
                return (_b = (_a = image.urls.medium) !== null && _a !== void 0 ? _a : image.urls.large) !== null && _b !== void 0 ? _b : image.urls.thumbnail;
            return (_d = (_c = image.urls.large) !== null && _c !== void 0 ? _c : image.urls.medium) !== null && _d !== void 0 ? _d : image.urls.thumbnail;
        }
        return (_f = (_e = image.urls.thumbnail) !== null && _e !== void 0 ? _e : image.urls.medium) !== null && _f !== void 0 ? _f : image.urls.large;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { className: classes.root, classes: undefined, elevation: 2 },
            React.createElement("div", { className: classes.card },
                React.createElement("div", { className: classes.img }, ((_a = props.item.images) === null || _a === void 0 ? void 0 : _a.length) > 1
                    ? (React.createElement(Carousel, { autoPlay: false, animation: "slide", fullHeightHover: true, navButtonsAlwaysVisible: true }, (_c = (_b = props.item) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.map((x, i) => (props.forceDocumentNavigation
                        ? React.createElement("a", { href: tourHref, key: i },
                            React.createElement("img", { src: resolveImageUrl(x), loading: "lazy", alt: x.description, title: x.description, key: i }))
                        : React.createElement(RouterLink, { to: tourUrl, key: i },
                            React.createElement("img", { src: resolveImageUrl(x), loading: "lazy", alt: x.description, title: x.description, key: i })))))) : (props.forceDocumentNavigation
                    ? React.createElement("a", { href: tourHref }, ((_d = props.item.images) === null || _d === void 0 ? void 0 : _d.length) == 1 ? (React.createElement("img", { src: resolveImageUrl(props.item.images[0]), alt: props.item.images[0].description })) : React.createElement(Box, { width: "100%", style: { minHeight: 190 } }))
                    : React.createElement(RouterLink, { to: tourUrl }, ((_e = props.item.images) === null || _e === void 0 ? void 0 : _e.length) == 1 ? (React.createElement("img", { src: resolveImageUrl(props.item.images[0]), alt: props.item.images[0].description })) : React.createElement(Box, { width: "100%", style: { minHeight: 190 } })))),
                React.createElement(Grid, { container: true, className: classes.cardMain, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12, md: 9 },
                        React.createElement(TourTitle, { title: props.item.name, type: props.item.typeName, url: tourUrl, href: tourHref, forceDocumentNavigation: props.forceDocumentNavigation }), (_g = (_f = cheapestPriceItem.accomodationVariants) === null || _f === void 0 ? void 0 : _f.sort((p1, p2) => p1.checkInDate > p2.checkInDate ? 1 : p1.checkInDate < p2.checkInDate ? -1 : 0)) === null || _g === void 0 ? void 0 :
                        _g.map((cheapestAccmd, i) => (React.createElement(React.Fragment, null,
                            React.createElement(TourLocation, { direction: props.item.directionName, accmmd: cheapestAccmd }),
                            React.createElement(TourDescription, { description: props.item.description }),
                            React.createElement(Box, { mb: 2, mt: 2 },
                                React.createElement(Divider, null)),
                            React.createElement(TourSummary, { tourDuration: cheapestAccmd.duration, tourStart: moment(cheapestAccmd.checkInDate).format('YYYY-MM-DD'), accmmd: cheapestAccmd }),
                            i < (cheapestPriceItem.accomodationVariants.length - 1) ?
                                React.createElement(Box, { mb: 2, mt: 2 },
                                    React.createElement(Divider, { variant: "inset" })) : null)))),
                    React.createElement(Grid, { item: true, xs: 12, md: 3, className: classes.cardActions },
                        React.createElement(Box, { flex: "1" },
                            React.createElement(TourActions, { tourUrl: tourUrl, tourHref: tourHref, tourVariant: cheapestVariant, priceItem: cheapestPriceItem, forceDocumentNavigation: props.forceDocumentNavigation, classes: classes, book: () => props.book(cheapestVariant, cheapestPriceItem.accomodationVariants, cheapestPriceItem.priceItem.servicesHash) })),
                        React.createElement(Button, { size: "small", fullWidth: true, className: classes.showMoreButton, endIcon: !isOpen ? React.createElement(ExpandMore, { fontSize: "small" }) : React.createElement(ExpandLess, { fontSize: "small" }), onClick: () => setIsOpen((prev) => !prev) }, _T.TOUR_SHOW_MORE_DATES)))),
            React.createElement(Collapse, { in: isOpen, mountOnEnter: true, unmountOnExit: true },
                React.createElement(Box, { className: classes.cardCollapse },
                    React.createElement(Typography, { variant: "h6", gutterBottom: true }, _T.TOUR_AVAILABLE_DATES),
                    React.createElement(TourVariantSelector, { item: props.item, book: props.book, genUrl: props.genUrl, forceDocumentNavigation: props.forceDocumentNavigation }))))));
}
export { TourSearchResultCard };
